import { useEffect, useState } from "react"
import { DateTime } from "luxon"

interface UseNowOptions {
  enabled?: boolean
  resetKey?: unknown
}

/**
 * The current time, taken again every `intervalMs` while `enabled`, for values that
 * have to move on with the clock. Enabling it again, or changing `resetKey`, takes
 * the time right away.
 */
const useNow = (
  intervalMs: number,
  { enabled = true, resetKey }: UseNowOptions = {},
): DateTime => {
  const [now, setNow] = useState(() => DateTime.now())

  useEffect(() => {
    if (!enabled) return
    setNow(DateTime.now())
    const interval = setInterval(() => setNow(DateTime.now()), intervalMs)
    return () => clearInterval(interval)
  }, [enabled, intervalMs, resetKey])

  return now
}

export default useNow
